import { Grid, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useEffect, useRef, useState } from 'react'
import { isAuditReviewWorkflow,isReviewWorkflow } from '../../core/workflow-api'
import {
  auditColumn,
  CollectionTable,
  Column,
  deleteColumn,
  editColumn,
  FilterControl,
  shimColumn,
} from '../../core/collections'
import { Auto, Search, Text } from '../../core/controls'
import { Expansion, ExpansionDetails, ExpansionSummary } from '../../core/expansion'
import { personName, personNameWithDegree, truncateSpan } from '../../core/format'
import { LostRevenueApi } from '../../core/lost-revenue-api'
import { onEditAction } from '../../core/audit'
import { orange } from '../../core/theme'
import { UndoRedo } from '../../core/undo-redo'
import { isResolved } from '../../core/worksheets'

export function LostRevenueForm(api: LostRevenueApi) {
  const form = useRef(api.form).current
  const { cptCode, reason, provider, comment } = form.controls

  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      style={{
        width: '100%',
        paddingLeft: '12px',
        paddingTop: '6px',
        paddingBottom: '8px',
      }}
    >
      <Grid item xs={2}>
        <Search {...cptCode} />
      </Grid>
      <Grid item xs={3}>
        <Auto {...reason} />
      </Grid>
      <Grid item xs={3}>
        <Auto {...provider} />
      </Grid>
      <Grid item xs={4}>
        <Text {...comment} />
      </Grid>
    </Grid>
  )
}

export function LostRevenueCollection(api: LostRevenueApi) {
  const { list, context } = api
  const { auditLostRevenue } = context.config
  const isReview = isAuditReviewWorkflow()

  const actions = isReview
    ? [
        auditColumn(
          onEditAction('Edit Lost Revenue Audit Comments', () => list.actions.refresh(), false, auditLostRevenue),
        ),
      ]
    : []

  const columns: Column[] = [
    {
      name: 'cptCode',
      label: 'Code',
      style: { width: '80px' },
      component: (e) => truncateSpan(e.value.cptCode, '80px'),
    },
    {
      name: 'reason',
      label: 'Reason',
      component: (e) => truncateSpan(e.value.reason, '80px'),
    },
    {
      name: 'physician',
      label: 'Physician',
      component: (e) => truncateSpan(personNameWithDegree(e.value.provider), '80px'),
    },
    {
      name: 'comment',
      label: 'Comments',
      component: (e) => truncateSpan(e.value.comment, '80px'),
    },
    ...actions,
    editColumn(
      (e) => api.editItem(e.value),
      (v) => !isResolved(v),
    ),
    deleteColumn(
      (e) => api.removeItem(e.value),
      (v) => !isResolved(v),
    ),
    shimColumn(),
  ]

  const values = list.data((s) => s.values)
  const [expanded, setExpanded] = useState(values.length > 0)
  const [clicked, setClicked] = useState(false)

  useEffect(() => {
    if (!clicked && !expanded) {
      setExpanded(values.length > 0)
    }
  })

  const onClicked = () => {
    setExpanded(!expanded)
    setClicked(true)
  }

  return (
    <Expansion expanded={expanded}>
      <ExpansionSummary onClick={onClicked} expandIcon={<ExpandMoreIcon id="lost_revenenue_expend_more" />}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 24,
            alignItems: 'center',
            flexWrap: 'nowrap',
          }}
        >
          <Typography variant="subtitle2">{`LOST REVENUE ${values.length ? '- ' + values.length : ''}`}</Typography>
          <div style={{ display: 'flex', flex: 1, flexGrow: 1 }} />

          <div onClick={(e) => e.stopPropagation()}>
            <UndoRedo api={api.listChanges} htmlColor={orange} label="lost-revenue" />
          </div>

          <FilterControl api={list} />
        </div>
      </ExpansionSummary>
      <ExpansionDetails>
        <CollectionTable
          readonly={api.context.readonly}
          columns={columns}
          api={list}
          containerProps={{ elevation: 0 }}
          name="lost-revenue-table"
          label={`Lost Revenue ${values.length ? '- ' + values.length : ''}`}
        />
      </ExpansionDetails>
    </Expansion>
  )
}
